import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import NoDataPlaceholder from '@kurtosys/ksys-app-components/dist/components/base/NoDataPlaceholder';
import VisuallyHidden from '@kurtosys/ksys-app-components/dist/components/base/VisuallyHidden';
import { IResultsProps, IResultsState } from './models';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import GroupHeading from './styledComponents/GroupHeading';
import GroupList from './styledComponents/GroupList';
import GroupListItem from './styledComponents/GroupListItem';
import List from './styledComponents/List';
import ListItem from './styledComponents/ListItem';
import GroupLabel from './styledComponents/GroupLabel';
import GroupRedirectLink from './styledComponents/GroupRedirectLink';
import ListItemLink from './styledComponents/ListItemLink';
import AllResultsListItem from './styledComponents/AllResultsListItem';
import AllResultsLink from './styledComponents/AllResultsLink';
import { computed } from 'mobx';
import { IResultItem } from '../App/models/IResultItem';
import { utils } from '@kurtosys/ksys-app-template';
import Translate from '@kurtosys/ksys-app-components/dist/components/base/Translate';

@inject('appStore', 'resultsStore')
@observer
export class Results extends Component<IResultsProps, IResultsState> {
	static configurationKey: 'results' = 'results';
	static styleKey: 'results' = 'results';
	constructor(props: IResultsProps) {
		super(props);
	}

	getResultComponent(resultItem: IResultItem) {
		const { link } = resultItem;
		return (
			<ListItem key={ `result_${ link.label }` }>
				<ListItemLink href={ link.href } onClick={ link.onClick } aria-label={ link.ariaLabel } target={ '_blank' }>
					{ link.label }
				</ListItemLink>
			</ListItem>
		);
	}

	@computed
	get results() {
		const { appStore } = this.props;
		if (appStore && appStore.groupedResults) {
			const { groupedResults } = appStore;
			return groupedResults.map((group) => {
				const { label, link } = group;
				const groupLabelId = `result_group_${ label }`;
				return (
					<GroupListItem key={ `group_list_item_${ label }` }>
						<GroupHeading>
							<GroupLabel id={ groupLabelId }>{ label }</GroupLabel>
							{ link && (
								<GroupRedirectLink href={ link.href } aria-describedby={ groupLabelId } onClick={ link.onClick } target={ '_blank' }>
									{ link.label }
								</GroupRedirectLink>
							) }
						</GroupHeading>
						<List aria-labelledby={ groupLabelId }>
							{
								group.items.map((resultItem) => {
									return this.getResultComponent(resultItem);
								})
							}
						</List>
					</GroupListItem>
				);
			});
		}
		return null;
	}

	render() {
		const { className, resultsStore, appStore } = this.props;

		if (!resultsStore || !appStore) {
			return null;
		}

		const { show, showNoResultsPlaceholder, showNoSearchTermPlaceholder, noResultsPlaceholder, noSearchTermPlaceholder, seeAllResultsLink } = resultsStore;

		if (!show) {
			return null;
		}

		const showPlaceholder = showNoResultsPlaceholder || showNoSearchTermPlaceholder;

		// v4 migration: Please update to use generateUniqueId instead of generateGuid()
		const summaryId = `summary_${ utils.guid.generateGuid() }`;

		return (
			<Wrapper className={ className }>
				{ showNoResultsPlaceholder && <NoDataPlaceholder>{ noResultsPlaceholder }</NoDataPlaceholder> }
				{ showNoSearchTermPlaceholder && <NoDataPlaceholder>{ noSearchTermPlaceholder }</NoDataPlaceholder> }
				{ !showPlaceholder && (
					<>
						<VisuallyHidden>
							<span id={ summaryId }>
								{/* v4 migration: Use a translation key for this and use the existing phrase as the default static text */ }
								<Translate>Grouped Search Results</Translate>
							</span>
						</VisuallyHidden>
						<GroupList aria-labelledby={ summaryId }>
							{ this.results }
							{
								seeAllResultsLink && (
									<AllResultsListItem key={ `group_list_item_all` } >
										<AllResultsLink href={ seeAllResultsLink.href } onClick={ seeAllResultsLink.onClick } target={ '_blank' }>
											{ seeAllResultsLink.label }
										</AllResultsLink>
									</AllResultsListItem>
								)
							}
						</GroupList>
					</>
				) }
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(Results, 'results');
